import React from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import getSummaryReports from "../../../api/summaryReport";
import Filters from "../Filters";
import * as calFns from "../../../components/Calendar/functions/calendarFunctions";
import SummaryReportTable from "./SummaryReportTable";
import { RootState } from "../../../store";

const ServiceCenterSummaryReport = ({
  resourceCentreId
}: {
  resourceCentreId?: number;
}): React.ReactNode => {
  const rcId =
    useSelector((state: RootState) => state.userContext?.resourceCentreId) || resourceCentreId;

  const [id, setId] = React.useState(null);
  const [isRequestLoading, setIsRequestLoading] = React.useState(false);
  const [summaryReportData, setSummaryReportData] = React.useState([]);

  const [filters, setFilters] = React.useState({
    from: calFns.startOfDay(new Date()).toDate(),
    until: new Date()
  });

  React.useEffect(() => {
    if (rcId) setId(rcId);
  }, [rcId]);

  React.useEffect(() => {
    setIsRequestLoading(true);
    getSummaryReports({ id, from: filters.from, until: filters.until })
      .then((response) => setSummaryReportData(response))
      .finally(() => setIsRequestLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
      {/* filter */}
      <Box sx={{ px: 3, py: 2 }}>
        <Filters
          filters={filters}
          onSetFilters={(newFilter) => setFilters(newFilter)}
          isRequestLoading={isRequestLoading}
        />
      </Box>

      {/* table */}
      <SummaryReportTable summaryReportData={summaryReportData} />
    </Box>
  );
};

export default ServiceCenterSummaryReport;
